import { getData, postData, updateData, deleteData } from "../services/apiService";

export const fetchCertifications = () => getData("/all-certifications");

export const fetchCertificationById = (id) => getData(`/certifications/${id}`);

export const createCertification = (formData) =>
  postData("/add-certification", formData, true);

export const editCertification = (id, formData) =>
  updateData(`/update-certification/${id}`, formData, true);

export const removeCertification = (id) =>
  deleteData(`/delete-certification/${id}`);
